import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { MainContentReaderBlockSchema } from './schema';
import type { MainContentReaderBlockData } from './index';

interface Props {
  data: MainContentReaderBlockData;
  block: string;
  onChangeBlock: (id: string, data: MainContentReaderBlockData) => void;
}

const Data: React.FC<Props> = ({ data, block, onChangeBlock }) => {
  const intl = useIntl();
  const schema = MainContentReaderBlockSchema({ props: data, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id: string, value: any) => {
        onChangeBlock(block, { ...data, [id]: value });
      }}
      formData={data}
      block={block}
    />
  );
};

export default Data;
